import { Component, OnInit } from '@angular/core';
import { MessagesService } from '../../../services/messages.service';
import { MSG_TYPE } from '../../../enum/message.enum';

@Component({
  selector: 'app-data-masking-controller',
  templateUrl: './data-masking-controller.component.html',
  styleUrls: ['./data-masking-controller.component.scss']
})
export class DataMaskingControllerComponent implements OnInit {
  isDataMasking = false;
  messageType = MSG_TYPE;

  constructor(
    public messagesService: MessagesService,
    ) { }

  ngOnInit(): void {
    this.isDataMasking = sessionStorage.getItem('dataMasking') === '1';
  }

  handleChangeMasking() {
    this.isDataMasking = !this.isDataMasking;
    sessionStorage.setItem('dataMasking', this.isDataMasking ? '1' : '0');
    this.messagesService.sendMessage({name: this.messageType.CHANGE_DATA_MASKING, value: this.isDataMasking});
  }
}
